<template>
  <div class="basket-article" :class="{ '-plan-c': planModel === 'c' }">

    <div class="basket-article__description">
      <div class="image">
        <ArticleImage :article="article"/>
      </div>
      <div class="text">
        <ArticleCaption :article="article"/>
        <BasketArticleDelete v-if="article.manuallyAdded && currentStatus !== 'completed'" :article="article"/>
      </div>
    </div>

    <div class="basket-article__quantity"  :data-mobile-label="cleanLineBreaks($t('sl.basket.headers.model_'+planModel+'.' + (isCollective? 'quantitySpecific': 'orderQuantity')))">
      <template v-if="article.manuallyAdded">
        <span v-if="planModel === 'b'">
           {{ manuallyAddedPackageUnit }}
        </span>
        <div>
          <quantity-input v-if="planModel === 'b'"
                          v-model="quantity"
                          :disabled="isUpdating || !isEditable"
                          ref="quantityInput"></quantity-input>
        </div>
      </template>
      <template v-else>
        <span>
          {{ orderSuggestionPackageUnit }}
        </span>
        <span>
          {{ article.orderSuggestionQuantity }}
        </span>
      </template>
    </div>

    <div
        v-if="planModel === 'c'"
        class="basket-article__input"
        :data-mobile-label="cleanLineBreaks($t('sl.basket.headers.model_'+planModel+'.adjustOrder'))"
    >
      <template v-if="article.manuallyAdded">
        <quantity-input
                        v-model="quantity"
                        :disabled="isUpdating || !isEditable"
                        ref="quantityInput"></quantity-input>
      </template>
      <template v-else>
        <quantity-input
                        v-model="quantity"
                        :classes=" article.orderSuggestionQuantity !== quantity ? 'primary-input-color' : ''"
                        :changed="article.orderSuggestionQuantity !== article.quantity"
                        :disabled="isUpdating || !isEditable"
                        ref="quantityInput"></quantity-input>
<!--        />-->
      </template>
    </div>

    <div
        v-if="planModel !== 'b'"
        class="basket-article__unit"
        :data-mobile-label="cleanLineBreaks($t('sl.basket.headers.model_'+planModel+'.packageUnit'))"
    >
      <BasketPackageSelect
          :is-editable="isEditable"
          :quantity="quantity"
          :packages="article.packages"
          :selected-package-id="article.articlePackageUnitId"
          :artno="article.artikelNrLAG"
      />
    </div>

    <div class="basket-article__total"
         :data-mobile-label="cleanLineBreaks($t('sl.basket.headers.model_'+planModel+'.price'))">
      {{
        totalPrice ? totalPrice.toLocaleString('de-CH', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) : '-'
      }}
    </div>
  </div>
</template>

<script>

import ArticleImage from '../../Article/ArticleImage.vue'
import ArticleCaption from '../../Article/ArticleCaption.vue'
import BasketPackageSelect from './BasketPackageSelect.vue'
import ArticleDetailDialog from "@/components/SmartLogistics/Article/ArticleDetailDialog.vue";
import BasketArticleDelete from "./BasketArticleDelete.vue";
import ArticleMessageIndicator from "@/components/SmartLogistics/Article/ArticleMessageIndicator.vue";
import {cleanLineBreaks} from "@/utils/String";
import QuantityInput from "@/components/shared/QuantityInput.vue";
import {mapGetters} from "vuex";

export default {
  name: 'BasketArticle',
  methods: {cleanLineBreaks},
  components: {
    QuantityInput,
    BasketArticleDelete,
    ArticleDetailDialog,
    BasketPackageSelect,
    ArticleCaption,
    ArticleImage,
    ArticleMessageIndicator
  },

  props: {
    article: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({
      isUpdating: 'smartLogisticBasket/isUpdating',
    }),
    currentStatus() {
      return this.$store.getters['smartLogisticOrderSuggestion/currentStatus']
    },

    planModel() {
      return this.$store.getters['smartLogisticSettings/planModel']
    },

    isCollective() {
      return  this.article.collective && this.article.storageLocation === 'warehouse'
    },

    quantity: {
      get() {
        return this.article.quantity
      },
      set(value) {
        this.$store.dispatch('smartLogisticBasket/updateArticle', {
          artikelNrLAG: this.article.artikelNrLAG,
          packageUnitID: this.article.articlePackageUnitId,
          quantity: value
        })
      }
    },

    totalPrice: {
      get() {
        let p = this.article.price * this.article.quantity

        return Math.round(p * 100) / 100
      }
    },
    currentPackageUnit() {
      try {
        return this.article.packages.filter((item) => {
          return item.id === this.article.artikelNrLAG + '-' + this.article.articlePackageUnitId
        })[0].label
      } catch (e) {
        return ''
      }
    },

    manuallyAddedPackageUnit() {
      try {
        return this.article.packages.filter((item) => {
          return item.id === this.article.artikelNrLAG + '-' + this.article.articlePackageUnitId
        })[0].label
      } catch (e) {
        return ''
      }
    },

    orderSuggestionPackageUnit() {
      if (!this.article.orderSuggestionPackageUnitId) {
        return this.article.unit;
      }
      try {
        return this.article.packages.filter((item) => {
          return item.id === this.article.artikelNrLAG + '-' + this.article.orderSuggestionPackageUnitId
        })[0].label
      } catch (e) {
        return ''
      }
    }
  }
}
</script>
<style>
.custom-select .v-input__control {
  min-height: 32px !important; /* Adjust this value as needed */
}

.custom-select .v-input__slot {
  min-height: 32px !important;
}

.custom-select .v-select__slot {
  height: 32px !important;
}

.custom-select .v-icon {
  top: -4px;
}

.primary-input-color {
  input {
    color: #ce20a8 !important;
  }
}

.article-message {
  margin-left: 5px;
}
</style>

